var initPostFilterTag = function initPostFilterTag() {
  var form = document.getElementById('post-filter-tag');
  if (form) {
    var radioInputs = form.querySelectorAll('.post-tag__input');
    radioInputs.forEach(function (radioInput) {
      radioInput.addEventListener('change', function () {
        form.submit();
      });
    });
  }
};
export { initPostFilterTag };